var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import axios from 'axios';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { captureException } from '@sentry/react';
import { createMessageThreadFailed, createMessageThreadRequested, createMessageThreadSucceeded, getCustomerInfoRequested, getCustomerInfoSucceeded, getMessageThreadsFailed, getMessageThreadsRequested, getMessageThreadsSucceeded, saveEmailFailed, saveEmailRequested, saveEmailSucceeded, } from './threadSlice';
import tryUploadFiles from '../../../utils/fileUpload';
function createMessageThread(action) {
    var _a, fileInfo, description, fscPayload, fileUploadResponses, data, messageThread, e_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 4, , 6]);
                _a = action.payload, fileInfo = _a.fileInfo, description = _a.description, fscPayload = __rest(_a, ["fileInfo", "description"]);
                return [4 /*yield*/, call(tryUploadFiles, fileInfo)];
            case 1:
                fileUploadResponses = _b.sent();
                return [4 /*yield*/, call(axios.post, '/customer/messages/threads', __assign(__assign({}, fscPayload), { description: description, messages: [
                            {
                                body: description,
                                files: fileUploadResponses,
                            },
                        ] }))];
            case 2:
                data = (_b.sent()).data;
                messageThread = {
                    id: data.id,
                    messages: data.messages,
                    relatedCase: {
                        number: undefined,
                        lastModifiedDate: new Date().toISOString(),
                        subject: action.payload.secureMessageDescription ||
                            "".concat(fscPayload.requestType, " ").concat(fscPayload.subLevelRequestType, " + ").concat(fscPayload.product),
                    },
                    lastModifiedDate: new Date().toISOString(),
                    unreadMessages: 0,
                };
                return [4 /*yield*/, put(createMessageThreadSucceeded(messageThread))];
            case 3:
                _b.sent();
                return [3 /*break*/, 6];
            case 4:
                e_1 = _b.sent();
                return [4 /*yield*/, put(createMessageThreadFailed(e_1))];
            case 5:
                _b.sent();
                captureException(e_1);
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function getCustomerInfo() {
    var res, email, isFramMember;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    return __generator(this, function (_m) {
        switch (_m.label) {
            case 0: return [4 /*yield*/, call(axios.post, '/customer/graph/graphql', {
                    query: "\n       query {\n         customer {\n           consentInformation {\n             focus {\n               value\n             }\n           }\n           coreInformation {\n             contactMethods {\n               emailPrivate {\n                 value\n               }\n             }\n           }\n         }\n       }\n  \n     ",
                }, {
                    headers: {
                        'X-Correlation-ID': "secure-messages-web.".concat(generateCorrelationId()),
                    },
                })];
            case 1:
                res = _m.sent();
                email = ((_f = (_e = (_d = (_c = (_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.customer) === null || _c === void 0 ? void 0 : _c.coreInformation) === null || _d === void 0 ? void 0 : _d.contactMethods) === null || _e === void 0 ? void 0 : _e.emailPrivate) === null || _f === void 0 ? void 0 : _f.value) || '';
                isFramMember = (_l = (_k = (_j = (_h = (_g = res.data) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.customer) === null || _j === void 0 ? void 0 : _j.consentInformation) === null || _k === void 0 ? void 0 : _k.focus) === null || _l === void 0 ? void 0 : _l.value;
                return [4 /*yield*/, put(getCustomerInfoSucceeded({ email: email, isFramMember: isFramMember }))];
            case 2:
                _m.sent();
                return [2 /*return*/];
        }
    });
}
function saveEmail(action) {
    var e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                return [4 /*yield*/, call(axios.patch, '/customer/core-data.v3', {
                        emailPrivate: action.payload,
                    })];
            case 1:
                _a.sent();
                return [4 /*yield*/, put(saveEmailSucceeded())];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3:
                e_2 = _a.sent();
                return [4 /*yield*/, put(saveEmailFailed(e_2))];
            case 4:
                _a.sent();
                captureException(e_2);
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function getMessageThreads(action) {
    var _a, limit, offset, response, currentRecords, updatedRecords, e_3;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 4, , 6]);
                _a = action.payload, limit = _a.limit, offset = _a.offset;
                return [4 /*yield*/, call(axios.get, "/customer/messages/threads?limit=".concat(limit, "&offset=").concat(offset))];
            case 1:
                response = _b.sent();
                return [4 /*yield*/, select(function (state) { return state.messageThreads.records; })];
            case 2:
                currentRecords = _b.sent();
                updatedRecords = __spreadArray(__spreadArray([], (currentRecords || []), true), response.data.content, true);
                return [4 /*yield*/, put(getMessageThreadsSucceeded({
                        totalSize: response.data.totalSize,
                        content: updatedRecords,
                    }))];
            case 3:
                _b.sent();
                return [3 /*break*/, 6];
            case 4:
                e_3 = _b.sent();
                return [4 /*yield*/, put(getMessageThreadsFailed(e_3))];
            case 5:
                _b.sent();
                captureException(e_3);
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function casesSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeLatest(getMessageThreadsRequested.type, getMessageThreads),
                    takeLatest(createMessageThreadRequested.type, createMessageThread),
                    takeLatest(getCustomerInfoRequested.type, getCustomerInfo),
                    takeLatest(saveEmailRequested.type, saveEmail),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function generateCorrelationId() {
    return Date.now().toString(36) + Math.random().toString(36).substring(2);
}
export default casesSaga;
